import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)(({ theme, size, variant }) => ({
  borderRadius: 14,
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '100%',

  ...(size === 'medium' && {
    minHeight: '46px',
    padding: '13px 16px',
  }),

  ...(size === 'large' && {
    minHeight: '54px',
    padding: '16px 24px',

    '& .MuiButton-startIcon': {
      marginRight: '13px',
    },

    '& .MuiButton-endIcon': {
      marginLeft: '13px',
    },
  }),

  ...(variant === 'contained' && {
    color: theme.palette.common.white,
    boxShadow: `0px 8px 19px -6px ${theme.palette.custom.opacityBlack25}`,

    '&:hover': {
      boxShadow: `0px 8px 19px -6px ${theme.palette.custom.opacityBlack25}`,
      backgroundColor: theme.palette.primary.dark,
    },

    '&:active': {
      boxShadow: `inset 0px 2px 8px 0px ${theme.palette.custom.opacityBlack25}`,
      backgroundColor: theme.palette.primary.main,
    },

    '&:disabled': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      opacity: 0.6,
    },

    '&.MuiButton-loading': {
      color: 'transparent',

      '& .MuiButton-loadingIndicator': {
        color: theme.palette.common.white,
      },
    },
  }),

  ...(variant === 'outlined' && {
    color: theme.palette.common.black,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.custom.grey1}`,
    boxShadow: `0px 8px 19px -6px ${theme.palette.custom.opacityBlack25}`,

    '&:hover': {
      border: `1px solid ${theme.palette.custom.black[40]}`,
    },

    '&:active': {
      boxShadow: `inset 0px 2px 8px 0px ${theme.palette.custom.opacityBlack25}`,
      border: `1px solid ${theme.palette.custom.grey1}`,
    },

    '&:focus-visible': {
      boxShadow: theme.shadows[5],
    },

    '&:disabled': {
      color: theme.palette.common.black,
      border: `1px solid ${theme.palette.custom.grey1}`,
      opacity: 0.6,
    },

    '&.MuiButton-loading': {
      color: 'transparent',

      '& .MuiButton-loadingIndicator': {
        color: theme.palette.primary.main,
      },
    },
  }),

  ...(variant === 'text' && {
    padding: 0,
    borderRadius: 0,
    minHeight: 'auto',

    '&:hover': {
      background: 'none',
      textDecoration: 'underline',
    },

    '&:active': {
      color: theme.palette.primary.dark,
      borderColor: theme.palette.primary.dark,
    },

    '&:focus-visible': {
      textDecoration: 'underline',
    },

    '&:disabled': {
      opacity: 0.6,
      color: theme.palette.custom.black[80],
    },

    '&.MuiButton-loading': {
      color: 'transparent',

      '& .MuiButton-loadingIndicator': {
        color: theme.palette.primary.main,
      },
    },
  }),
}));
